import { createIcon } from './icon-utils';

export const BoldIcon = createIcon({
  path: 'M13.125 11.061H8.812v8.625h4.313a4.312 4.312 0 1 0 0-8.625zm0-1.5h.563a2.625 2.625 0 1 0 0-5.25H8.811v5.25h4.313zM7.312 19.686V4.311h-1.5a.75.75 0 0 1 0-1.5h7.875a4.125 4.125 0 0 1 2.338 7.524 5.813 5.813 0 0 1-2.9 10.851H5.812a.75.75 0 1 1 0-1.5h1.5z',
});

// Modified version of Streamline's superscript icon with larger "2"
